import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const santanderTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.santander,
  logoUrl: "https://cdn.nemuru.com/assets/logos/santander-logo.svg",
  palette: {
    primary: {
      main: "#EC0000",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#333",
      contrastText: "#fff",
    },
    dark: {
      main: "#f7f7f7",
      contrastText: "#333a42",
      accent: "#990000",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#000",
      primary: "#333a42",
      secondary: "#6c6c6c",
    },
    status: {
      active: "#63BA68",
      approved: "#08a649",
      analysing: "#1b4dbc",
      sent: "#133788",
      cancelled: "#d8d8d8",
      denied: "#EC0000",
    },
    info: {
      main: "#1bb3bc",
      contrastText: "#ffffff",
      light: "#deedf2",
    },
    warning: {
      main: "#ffcd00",
      contrastText: "#ffffff",
      light: "#ffcd008a",
    },
    success: {
      main: "#63BA68",
      contrastText: "#ffffff",
      light: "#63ba6875",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f7f7f7",
  customBorderRadius: {
    button: 0,
    paper: 0,
  },
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
  },
};
